import { EditFilled } from "@ant-design/icons";
import { useBucketById } from "@entities/bucket/lib/hooks/useBucketById";
import { BucketUpdateForm } from "@entities/bucket/ui/BucketUpdateForm";
import { InfluencerTable } from "@shared/ui/InfluencerTable/InfluencerTable";
import { Button, Col, Divider, Flex, Modal, Row } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { ROUTES } from "@app/constants";
import CampaignReachoutInfluencerModal from "@entities/campaign-reach-out/ui/CampaignReachoutModal";
import { useDownloadBucketInfluencers } from "@entities/discovery/lib/hooks/useDownloadInfluencers";
import { useBulkUploadInfluencers } from "@entities/influencer/lib/hooks/useBulkUploadInfluencers";
import { InfluencerBulkUploadForm } from "@entities/influencer/ui/InfluencerBulkUploadForm";
import { ICreator } from "@shared/lib/types";
import { PageHeader } from "@widgets/PageHeader";

export function BucketInfluencerPage() {
  const { bucketId } = useParams();
  const { bucket, isFetching } = useBucketById(bucketId!);
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedCreators, setSelectedCreators] = useState<ICreator[]>([]);
  const { downloadInfluencers } = useDownloadBucketInfluencers();
  const [isCampaignReachOutModalVisible, setCampaignReachOutModalVisible] =
    useState<boolean>(false);

  const [isBulkInfluencerModalVisible, setBulkInfluncerModalVisible] =
    useState(false);

  const {
    update: bulkUploadInfluencers,
    isUpdated,
    isUpdating,
  } = useBulkUploadInfluencers();

  const handleBulkInfluencerModalSubmit = (inputFileUrl: string) => {
    bulkUploadInfluencers({ inputFileUrl, bucketId });
    setBulkInfluncerModalVisible(false);
  };

  const ButtonComponent = () => {
    return (
      <Col
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        {selectedCreators.length > 0 && (
          <Button
            onClick={() => {
              selectedCreators?.forEach((influencer) => {
                if (influencer?.link) {
                  window.open(influencer?.link || "", "_blank");
                }
              });
            }}
            style={{ marginRight: 10 }}
          >
            Open Profile Links
          </Button>
        )}

        {selectedCreators.length > 0 && (
          <Button onClick={() => setCampaignReachOutModalVisible(true)}>
            Campaign Reach Out
          </Button>
        )}
      </Col>
    );
  };

  const ActionButtons = () => {
    return (
      <Flex gap={10}>
        <Row>
          <Button
            type="link"
            onClick={() => setBulkInfluncerModalVisible(true)}
          >
            Bulk Upload Influencers
          </Button>
        </Row>
        <Row>
          <Button
            type="link"
            onClick={() => downloadInfluencers({ bucketId: bucketId || "" })}
          >
            Download
          </Button>
        </Row>
      <Button disabled={isFetching} onClick={() => setModalVisible(true)}>
        <EditFilled />
      </Button>
      </Flex>
    );
  };

  return (
    <>
      <PageHeader 
        title={`Bucket - ${bucket?.name}`}
        backText="Buckets"
        backTo={ROUTES.BUCKET}
      />
      <InfluencerTable
        isFromBuckePage={true}
        bucketName={`Bucket - ${bucket?.name}`}
        bucketId={bucketId}
        ButtonComponent={ButtonComponent}
        TopEditButton={ActionButtons}
        selectedCreators={selectedCreators}
        setSelectedCreators={setSelectedCreators}
      />
      <Modal
        title={"Update Bucket"}
        open={isModalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Divider style={{ marginTop: 10 }} />
        <BucketUpdateForm
          closeModal={() => setModalVisible(false)}
          bucketId={bucketId!}
          oldvalues={{
            bucketName: bucket?.name!,
            bucketCategory: bucket?.category!,
            bucketDescription: bucket?.description!,
          }}
        />
      </Modal>

      <Modal
        title={"Bulk Upload Influencers"}
        open={isBulkInfluencerModalVisible}
        onCancel={() => {
          setBulkInfluncerModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <InfluencerBulkUploadForm onSubmit={handleBulkInfluencerModalSubmit} />
        {/* <BrandForm onSubmit={handleSubmit} isSubmitting={isCreating} /> */}
      </Modal>

      <CampaignReachoutInfluencerModal
        visible={isCampaignReachOutModalVisible}
        onClose={() => setCampaignReachOutModalVisible(false)}
        userData={selectedCreators?.map((ele) => ({
          name: ele.name,
          platform: ele.platform,
          username: ele.username,
          profilePicUrl: ele.profilePicUrl,
          link: ele.link,
        }))}
      />
    </>
  );
}
